import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";

type MessageType = "user" | "assistant";

interface ChatMessageProps {
  type: MessageType;
  message: string;
  loading: boolean;
}

export const ChatMessage: React.FC<ChatMessageProps> = ({ type, message, loading }) => {
  const isAssistant = type === "assistant";
  
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: isAssistant ? "flex-end" : "flex-start",
        alignItems: "center",
        mb: 2,
        wordBreak: "break-word",
        width: "100%"
      }}
    >
      <Box
        sx={{
          maxWidth: "90%",
          py: 2,
          px: 3,
          borderRadius: isAssistant ? "30px 30px 5px 30px" : "20px 20px 0px 20px",
          bgcolor: isAssistant ? "#fff" : "#DAB0DA",

          color: isAssistant ? "black" : "black",
          boxShadow: isAssistant ? "none" : "0px 1px 3px rgba(0,0,0,0.1)",
          border:  "1px solid #E5E5E5",
        }}
      >
        <Typography variant="body1" sx={{ fontSize: "16px", wordBreak: "break-word" }} dangerouslySetInnerHTML={{ __html: message }} />
        
      </Box>
      {loading && (
             <CircularProgress size={24} sx={{ margin: '0 4px' }} />
          )}
    </Box>
  );
};
